import { Injectable } from '@angular/core';
import {
  initializeDevCycle,
  DevCycleOptions,
  DevCycleClient,
  DevCycleUser,
} from '@devcycle/js-client-sdk';
import { environment } from '@env/environment';
import { AuthManagerService } from './auth-manager.service';

@Injectable({
  providedIn: 'root',
})
export class DevCycleService {
  devcycleClient: DevCycleClient;
  isReady = false;

  constructor(private authManagerService: AuthManagerService) {
    const dvcOptions: DevCycleOptions = { logLevel: 'error' };
    const devCycleUser = sessionStorage.getItem('devCycleUser')
      ? JSON.parse(sessionStorage.getItem('devCycleUser') as string)
      : ({} as DevCycleUser);

    this.devcycleClient = initializeDevCycle(
      environment.devCycleSdkKey,
      devCycleUser,
      dvcOptions,
    );

    this.devcycleClient.onClientInitialized((err) => {
      if (err) {
        throw err;
      }

      this.isReady = true;
    });
  }

  public async getVariable(
    variableName: string,
    defaultValue: boolean,
  ): Promise<boolean> {
    const customData: { [key: string]: any } = {
      ...this.devcycleClient.user?.customData,
    };

    // Only add agencyCompanyId and companyId if the user is authenticated
    if (this.authManagerService.isAuthenticated()) {
      const agencyCompanyId =
        this._getParsedLocalStorageItem('agency_company_id');
      const companyId = localStorage.getItem('company');

      if (agencyCompanyId) {
        customData['agencyCompanyId'] = agencyCompanyId;
      }
      if (companyId) {
        customData['companyId'] = companyId;
      }
    }

    const newUser = {
      ...this.devcycleClient.user,
      customData: customData,
    };

    await this.devcycleClient.identifyUser(newUser);

    if (this.isReady) {
      return this.devcycleClient.variableValue(variableName, defaultValue);
    }

    return false;
  }

  private _getParsedLocalStorageItem(key: string): number | null {
    const item = localStorage.getItem(key);
    return item ? parseInt(item, 10) : null;
  }
}
